export default {
  'contact-mail': 'blog@pixartprinting.com',
  'business-name': 'Pixartprinting S.p.A. ',
  'privacy-policy': 'Privacy policy',
}
